import country from '@/libs/country.json'

export const useCountry = ({
  fuzzy = false,
  countryKey = 'id',
  areaKey = 'id',
  cityKey = 'id',
}) => {
  const countryList = ref()
  const areaList = ref()
  const cityList = ref()
  const countryLoading = ref(false)
  const areaLoading = ref(false)
  const cityLoading = ref(false)

  const normalizeName = (str: string) => {
    // 移除所有类型空格（普通空格、非断空格等）并转小写
    return str.replace(/[\s\u00A0]/g, '').toLowerCase()
  }

  const getCountryList = async () => {
    try {
      countryLoading.value = true
      const res = await commentService.getCountryList()
      countryList.value = res.map((item: any) => {
        if (normalizeName(item.name) === normalizeName('Frech Polynesia')) {
          item.name = 'French Polynesia'
        }
        let obj = country.find(v => normalizeName(v.name) === normalizeName(item.name))
        // 法属
        if (['Reunion', 'Frech Polynesia'].includes(item.name)) {
          obj = country.find(v => normalizeName(v.name) === normalizeName('France'))
        }
        if (['Aland lslands'].includes(item.name)) {
          obj = country.find(v => normalizeName(v.name) === normalizeName('Aland Islands'))
        }
        // if (!obj) console.log('obj', item.name, item)
        const v = {
          label: item.name,
          value: item[countryKey],
          flag_4x3: obj?.flag_4x3 && new URL(`../assets/${obj?.flag_4x3}`, import.meta.url).href,
          ...item,
          obj: obj,
        }
        return v
      })
    } catch (error) {
      console.error(error)
    } finally {
      countryLoading.value = false
    }
  }

  const getAreaList = async (areaId: number | string) => {
    if (!areaId) return
    try {
      areaLoading.value = true
      const res = await commentService.getAreaList(areaId)
      areaList.value = res.map((item: any) => {
        return {
          label: item.name,
          value: item[areaKey],
          ...item,
        }
      })
    } catch (error) {
      console.error(error)
    } finally {
      areaLoading.value = false
    }
  }

  const getCityList = async (areaId: number | string) => {
    if (!areaId) return
    try {
      areaLoading.value = true
      const res = await commentService.getAreaList(areaId)
      cityList.value = res.map((item: any) => {
        return {
          label: item.name,
          value: item[cityKey],
          ...item,
        }
      })
    } catch (error) {
      console.error(error)
    } finally {
      areaLoading.value = false
    }
  }

  const fuzzyCountry = async () => {
    try {
      countryLoading.value = true
      const res = await walletService.fuzzyCountry()
      countryList.value = res.map((item: { countryName: string; fiatCurrencyCode: string }) => {
        if (normalizeName(item.countryName) === normalizeName('Frech Polynesia')) {
          item.countryName = 'French Polynesia'
        }
        let obj = country.find(v => normalizeName(v.name) === normalizeName(item.countryName))
        // 法属
        if (['Reunion', 'Frech Polynesia'].includes(item.countryName)) {
          obj = country.find(v => normalizeName(v.name) === normalizeName('France'))
        }
        if (['Aland lslands'].includes(item.countryName)) {
          obj = country.find(v => normalizeName(v.name) === normalizeName('Aland Islands'))
        }
        // if (!obj) console.log('obj', item.name, item)
        const v = {
          label: item.countryName,
          value: item[countryKey || 'countryName'],
          flag_4x3: obj?.flag_4x3 && new URL(`../assets/${obj?.flag_4x3}`, import.meta.url).href,
          ...item,
          obj: obj,
        }
        return v
      })
    } catch (error) {
      console.error(error)
    } finally {
      countryLoading.value = false
    }
  }

  onMounted(() => {
    if (fuzzy) {
      fuzzyCountry()
    } else {
      getCountryList()
    }
  })

  return {
    countryList,
    areaList,
    cityList,
    countryLoading,
    areaLoading,
    cityLoading,
    getCountryList,
    getAreaList,
    getCityList,
  }
}
